import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "./api";
import { useAuth } from "./auth";

const PersonalizationContext = createContext(null);

const EMPTY = { custom_tasks: [], agent_note: "", key_dates: {}, custom_vendors: [], seller_tasks: [], custom_date_fields: [], hidden_date_fields: [], under_contract: {}, annual_property_taxes: null, net_sheet_closing_date: null, offers: [] };

export function PersonalizationProvider({ children }) {
  const { user } = useAuth();
  const [p, setP] = useState(EMPTY);
  const [loaded, setLoaded] = useState(false);

  const refresh = useCallback(async () => {
    if (!user || user.role === "admin") { setP(EMPTY); setLoaded(true); return; }
    try {
      const { data } = await api.get("/me/personalization");
      setP({ ...EMPTY, ...(data.personalization || {}) });
    } catch {
      setP(EMPTY);
    } finally { setLoaded(true); }
  }, [user]);

  useEffect(() => { refresh(); }, [refresh]);

  return (
    <PersonalizationContext.Provider value={{ p, loaded, refresh }}>
      {children}
    </PersonalizationContext.Provider>
  );
}

export const usePersonalization = () => useContext(PersonalizationContext) || { p: EMPTY, loaded: true, refresh: () => {} };
